import React from 'react';
import { PieChart, Pie, Legend, Tooltip, Cell, Label, Sector, ResponsiveContainer } from 'recharts';
import classnames from 'classnames';
import { map, get, slice, isNil } from 'lodash';
import ReactTooltip from 'react-tooltip';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { ColorConfigInActive as InActiveColorLegend, ColorConfig as ActiveColorConfig } from 'config/piechart-configs/resolution-config';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { pieChart as PieChartView } from './pieChart.view';
 *
 * // render
 * <PieChartView propName='propValue'/>
 */

const RenderActiveShape = ( props ) => {
    const { cx, cy, outerRadius, startAngle, endAngle, fill } = props;
  
    return (
      <g>
        <Sector
          cx={ cx }
          cy={ cy }
          outerRadius={ outerRadius }
          startAngle={ startAngle }
          endAngle={ endAngle }
          fill={ fill }
        />
        <Sector
          cx={ cx }
          cy={ cy }
          startAngle={ startAngle }
          endAngle={ endAngle }
          outerRadius={ outerRadius + 5 }
          fill={ fill }
        />
        {/* <text x={ex + ( 0 <= cos ? 1 : -1 ) * 12 } y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text> */}
      </g>
    );
  };

    const RADIAN = Math.PI / 180;
    const RenderCustomizedLabel = ( labelProps ) => {

    const  { cx, cy, midAngle, innerRadius, outerRadius, value } = labelProps;
    const radius = innerRadius + ( outerRadius - innerRadius ) * 1.2;
    const x  = cx + radius * Math.cos( -midAngle * RADIAN );
    const y = cy  + radius * Math.sin( -midAngle * RADIAN );
    
    return (
        <text x={ x } y={ y } fill="black" textAnchor={ x > cx ? 'start' : 'end' } dominantBaseline="central" >
            { value }
        </text>
    );
    };
      
export const pieChartSuccess = ( props ) => {

    const widgetClassName = classnames( 'ui-pie-chart', props.className );
    const {
			cy,
			cx,
			outerRadius,
			labelLine,
			data,
			layout,
			isAnimationActive,
			activeIndex,
			verticalAlign,
			onLegendClick,

            // colorConfig,
			margin,

			// height,
			// width,
			onPieClick,
		} = props;

    const renderLegend = ( legendprops ) => {
		const { payload } = legendprops;
		const innerArray = slice( payload, 8, payload.length );

		return (
			<ul>
				{ map( payload, ( entry, index ) => (
					<>
						{ 8 > index && (
							<li
								key={ `item-${ index } ` }
								className={classnames( 'ui-pie-chart__legend', {
									'ui-pie-chart__legend__active': activeIndex === index,
								} ) }
								onClick={ () => onLegendClick( index ) }
							>
								<span style={ { backgroundColor: InActiveColorLegend[ index ] } } />
								{ `${ get( entry, 'payload.tooltip', '' ) }` }
							</li>
						) }
						{ 8 === index && (
							<>
								<li
									key={ `otheritem-${ index }` }
									data-tip="custom show"
									data-event="click focus"
									className={ classnames( 'ui-pie-chart__legend' ) }
								>
									<span style={ { backgroundColor: InActiveColorLegend[ index ] } } />
									{ 'Others' }
								</li>

								{/* Tooltip occur when legend is more than 8 */}
								<ReactTooltip
									globalEventOff="click"
									clickable={ true }
									backgroundColor="#f2f2f2"
									textColor="#000"
									className="ui-pie-chart__legend__tooltip"
									place="right"
								>
									{ map( innerArray, ( value, iterate ) => {
										return (
											<li
												key={ `toolItem-${ iterate + index }` }
												className={ classnames(
													'ui-pie-chart__legend ui-pie-chart__legend__tooltipLegend',
													{
														'ui-pie-chart__legend__active':
															activeIndex === iterate + index,
													}
												)}
												onClick={ () => onLegendClick( iterate + index ) }
											>
												<span
													style={ { backgroundColor: InActiveColorLegend[ iterate + index ] } }
												/>
												{`${ get( value, 'payload.tooltip', '' ) }` }
											</li>
										);
									} ) }
								</ReactTooltip>
							</>
						) }
					</>
				) ) }
			</ul>
		);
	};


    //Custom tooltip as per SD
    const customTooltip = ( { active, payload } ) => {
        
        const color = get( payload, '0.payload.fill', '#fff' );
        const tooltip = get( payload, '0.payload.tooltip', '#fff' );
        const label = get( payload, '0.name', '' );

        if ( active ) {
        return (
                <React.Fragment>
                    <div className="ui-pie-chart__custom-tooltip__triangle-right"></div>
                    <div className='ui-pie-chart__custom-tooltip'>
                        <span style={ { backgroundColor: color } } />{ `${ label }  ${ tooltip }` }
                    </div>
                </React.Fragment>
            );
        }
        return null;
    };

    return (
        <div className={ widgetClassName }>

            {/* Container deal with dynamic Chart height and Width  */}
            <ResponsiveContainer >

                <PieChart margin= { margin }>
                    <Pie
                        isAnimationActive={ isAnimationActive }
                        data={ data }
                        cx={ cx } cy={ cy }
                        outerRadius={ outerRadius }
                        label={ <RenderCustomizedLabel /> }
                        labelLine={ labelLine }
                        onClick={ onPieClick }
                        activeIndex={ activeIndex }
                        dataKey="value"
						activeShape={ <RenderActiveShape /> }

						// minAngle={ 2 }
						// paddingAngle={ '2.4' }
                        >
                        {
							map( data, ( entry, index ) => {

								let colorFile = InActiveColorLegend;

								if( ! isNil( activeIndex ) ) {

									if( index === activeIndex ) {
										colorFile = InActiveColorLegend;
									} else {
										colorFile = ActiveColorConfig;
									}
								}
								return(
									<Cell key={ index } fill={ colorFile[ index ] }/>
								);
							} )
                        }
                    </Pie>

                    <Label fill="#000" className='ui-pie-chart__label' />

                    <Legend  content={ renderLegend } wrapperStyle={ { left: 250 } }  layout={ layout } verticalAlign={ verticalAlign } />
                    
                    <Tooltip content={ customTooltip } wrapperStyle={ { display: 'flex'} }  />
                </PieChart>

            </ResponsiveContainer>
        </div>
    );
};

// set display name
pieChartSuccess.displayName = 'pieChartSuccess';

// set default props
pieChartSuccess.defaultProps = {};

// prop types
pieChartSuccess.propTypes = {};

/* ******************************************************** */

export const pieChartPreloader = () => {
	return (
		<div className="ui-pie-chart-preloader">
			<div className="ui-pie-chart-preloader__chart">
				<div className="ui-pie-chart-preloader__chart__legend">
				</div>
			</div>
			<div className="ui-pie-chart-preloader__details">
				{ map( [ 1, 2, 3, 4 ], ( item ) => {
					return (
						<div key={ 'bar-loader' + item }>
							<div className="ui-pie-chart-preloader__details__section">
								<div className="ui-pie-chart-preloader__details__section__label" />
								<div className="ui-pie-chart-preloader__details__section__value" />
							</div>
							<div className="ui-pie-chart-preloader__details__section">
								<div className="ui-pie-chart-preloader__details__section__label" />
								<div className="ui-pie-chart-preloader__details__section__value" />
							</div>
						</div>
					);
				} )}
			</div>
		</div>
	);
};

// set display name
pieChartPreloader.displayName = 'pieChartPreloader';

// set default props
pieChartPreloader.defaultProps = {};

// prop types
pieChartPreloader.propTypes = {};

/* ******************************************************** */

export const pieChart = withNetworkState( pieChartPreloader, pieChartSuccess );
